import { StringDecoder } from 'string_decoder';

export const scrollLockOn = () => {
  document.getElementsByTagName('html')[0].classList.add('no-scroll');
};

export const scrollLockOff = () => {
  document.getElementsByTagName('html')[0].classList.remove('no-scroll');
};

export const resetScrollPos = () => {
  if (typeof window !== 'undefined') {
    setTimeout(() => {
      window.scrollTo(0, -40);
    }, 500);
  }
};

export const detectBrowser = () => {
  if (typeof window !== 'undefined') {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE');
    const trident = ua.indexOf('Trident/');
    const iPhone = !!ua.match(/iPhone/i);
    const iPad = ua.match(/iPad/i) != null;
    const webkit = !!ua.match(/WebKit/i);
    const iOSSafari = iPhone && webkit && !ua.match(/CriOS/i);

    if (msie !== -1 || trident !== -1) {
      return 'IE';
    } else if (iOSSafari) {
      return 'iOS';
    } else if (iPad) {
      return 'iPad';
    } else {
      return false;
    }
  }
};

export const isMobileDevice = () => {
  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  );
};

export const filterProjects = (allProjects, projectList) => {
  const projects = allProjects.filter((project, index) => {
    return projectList.indexOf(project.node.slug) != -1;
  });
  return projects;
};

export const filterPosts = (allPosts, filterName) => {
  const posts = allPosts.filter(post => {
    return post.node.categories[0].name === filterName;
  });
  return posts;
};

export const chunk = (array, size) => {
  const chunked_arr = [];
  if (typeof array === 'undefined' || array.length === 0) {
    return chunked_arr;
  }
  let index = 0;
  while (index < array.length) {
    chunked_arr.push(array.slice(index, size + index));
    index += size;
  }
  return chunked_arr;
};

const updateLocationName = location => {
  const locationSplit = location.split('/');
  const locationFiltered = locationSplit.filter(value => {
    if (value !== '') {
      return value;
    }
  });
  return locationFiltered;
};

export const displayHeader = headerLocation => {
  const locationSlashless = headerLocation.split('/')[1];
  const locationDownload = headerLocation.split('/')[2];
  if (locationDownload === 'download') {
    return true;
  }
  switch (locationSlashless) {
    case 'webinar':
      return false;
      break;
    default:
      return true;
      break;
  }
};

export const showHeaderColor = headerLocation => {
  const locationSlashless = headerLocation.split('/')[1];
  const location = updateLocationName(headerLocation);

  if (location.length > 1) {
    // is a sub page
    switch (locationSlashless) {
      case 'our-work':
        return false;
        break;
      case 'capabilities':
        return false;
        break;
      default:
        break;
    }
    return true;
  }

  switch (locationSlashless) {
    case 'amplify':
      return true;
      break;
    case 'anniversary':
      return true;
      break;
    case 'awkwardoffice':
      return true;
      break;
    case 'blog':
      return true;
      break;
    case 'brandwithjk':
      return true;
      break;
    case 'contact':
      return true;
      break;
    case 'employerbranding-webinar':
      return true;
      break;
    case 'internalcomms':
      return true;
      break;
    case 'happyholidays2020':
      return true;
      break;
    case 'job-success':
      return true;
      break;
    case 'not-found':
      return true;
      break;
    case 'people':
      return true;
      break;
    case 'our-work':
      return true;
      break;
    case 'payment':
      return true;
      break;
    case 'payment-success':
      return true;
      break;
    case 'privacy-policy':
      return true;
      break;
    case 'qa':
      return true;
    case 'site-map':
      return true;
      break;
    case 'terms-of-service':
      return true;
      break;
    case 'workplacebranding':
      return true;
      break;
    case '13questions':
      return true;
      break;
    default:
      break;
  }
};

export const convertDate = date => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  let dateMod = date.substring(0, date.indexOf('T')).split('-');
  const month = monthNames[parseInt(dateMod[1], 10) - 1];
  const day = dateMod[2];
  const year = dateMod[0];
  return `${month} ${day}, ${year}`;
};

export const fullYear = () => {
  const date = new Date();
  return date.getFullYear();
};

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const stripHTML = html => {
  if (typeof window !== 'undefined') {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText;
  }
};

const isProjectHome = state => ({
  home: () => {
    if (
      typeof state.mappedIndex !== 'undefined' &&
      typeof state.currentSectionIndex !== 'undefined'
    ) {
      return true;
    } else {
      return false;
    }
  },
});

const returnSection = state => ({
  section: () => {
    if (state.mappedIndex + 1 === state.currentSectionIndex) {
      return 'active';
    } else {
      return 'inactive';
    }
  },
});

export const detectSection = (mappedIndex, currentSectionIndex) => {
  let state = {
    mappedIndex: mappedIndex,
    currentSectionIndex: currentSectionIndex,
  };

  return Object.assign(state, isProjectHome(state), returnSection(state));
};

export const returnSectionBoolean = detectSectionFn => {
  if (detectSectionFn() === 'active') {
    return true;
  } else {
    return false;
  }
};

export const returnDepartmentTitle = (departments, id) => {
  return departments.filter((department, index) => {
    if (department.id === id) {
      return department.title;
    }
  });
};

export const returnDepartmentNodeTitle = (departments, id) => {
  return departments.filter((department, index) => {
    if (department.node.wordpress_id === id) {
      return department.node.slug;
    }
  });
};

export const checkActivePage = (url, styles) => {
  const defaultItem = styles.item;
  const activeItem = [styles.item, styles.active].join(' ');
  const urlSlashless = url.split('/')[1];
  const locationSlashless = location.pathname.split('/')[1];
  if (locationSlashless === urlSlashless) {
    return activeItem;
  } else {
    return defaultItem;
  }
};

export const replaceBreakWithSpace = str => {
  return str.replace(/<br\s*\/?>/gi, ' ');
};



// WEBPACK FOOTER //
// ./src/utils/helper-functions/index.js